var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _rect3, _rect4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _path14, _circle2, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyImageGreen = function SvgEmptyImageGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 183 183"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 183,
    fill: "#E5F2F5",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "M160.64 149.948a1.02 1.02 0 0 0-.407-1.387l-32.434-17.714a1.02 1.02 0 0 0-1.386.407l-9.566 17.514a1.02 1.02 0 0 0 .407 1.387l32.434 17.714a1.02 1.02 0 0 0 1.386-.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "m137.176 136.827-9.691 17.744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    d: "M132.295 139.396a1.35 1.35 0 0 0-.537-1.829l-2.957-1.615a1.348 1.348 0 1 0-1.292 2.365l2.957 1.616a1.35 1.35 0 0 0 1.829-.537"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "#BFD4D9",
    rx: 3.37,
    transform: "scale(-1 1)rotate(-28.642 215.741 382.738)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M62.474 142.577 63 141l.526 1.577a3 3 0 0 0 1.897 1.897L67 145l-1.577.526a3 3 0 0 0-1.897 1.897L63 149l-.526-1.577a3 3 0 0 0-1.897-1.897L59 145l1.577-.526a3 3 0 0 0 1.897-1.897"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m153.62 103.639 5.331-15.101a1.047 1.047 0 1 0-2.012-.566zM148.983 101.769l5.656-15.301a.716.716 0 1 0-1.362-.437zM137.855 97.28l6.544-14.942a.717.717 0 1 1 1.284.63z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 4,
    x: 152.935,
    y: 83.953,
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    transform: "rotate(21.97 152.935 83.953)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 142.734,
    y: 79.838,
    fill: "#fff",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    transform: "rotate(21.97 142.734 79.838)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m158.273 85.74 8.11-13.27M152.382 82.652l3.757-14.66M155.441 84.425l6.023-14.284"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M154.289 68.28s3.203.603 6.759 2.038 6.281 3.223 6.281 3.223"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M154.289 68.28s3.203.603 6.759 2.038 6.281 3.223 6.281 3.223"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "M40.655 39.754c-.269-.797-.451-1.338-.626-1.744-.17-.396-.3-.582-.42-.7a1.95 1.95 0 0 0-1.077-.534c-.167-.025-.394-.016-.812.088-.43.106-.97.288-1.768.556l-14.897 5.014c-.797.268-1.338.45-1.744.626-.396.17-.582.3-.7.42-.288.294-.475.67-.535 1.077-.024.167-.015.393.089.811.106.43.287.97.556 1.768l3.555 10.565c.269.797.451 1.338.626 1.744.17.396.3.582.42.7.294.287.671.474 1.077.534.168.025.394.016.812-.088.43-.106.97-.288 1.768-.556l14.897-5.014c.797-.268 1.338-.45 1.744-.626.396-.17.582-.3.7-.42.288-.294.475-.67.535-1.077.024-.167.015-.393-.089-.811-.106-.43-.287-.97-.556-1.768z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "M41.884 48.184c-.269-.798-.451-1.339-.626-1.745-.17-.396-.3-.581-.42-.7a1.95 1.95 0 0 0-1.077-.534c-.167-.025-.394-.016-.812.088-.43.107-.97.288-1.768.556l-6.06 2.04c-.954.32-1.612.543-2.109.757-.486.209-.736.377-.904.548a2.53 2.53 0 0 0-.696 1.403c-.035.237-.018.538.11 1.051.13.525.35 1.184.672 2.137l.28.835c.322.954.544 1.612.758 2.109.209.486.377.736.548.903.382.375.873.619 1.403.697.237.035.537.017 1.05-.11.526-.13 1.184-.35 2.138-.672l6.06-2.04c.798-.268 1.339-.45 1.745-.626.396-.17.582-.3.7-.42.287-.293.474-.67.535-1.077l.989.146-.99-.146c.025-.167.016-.393-.088-.811-.106-.43-.288-.97-.556-1.768zM51.016 20.38c-.32-.954-.543-1.612-.757-2.109-.209-.486-.377-.736-.548-.904a2.53 2.53 0 0 0-1.403-.696c-.237-.035-.538-.018-1.051.11-.525.13-1.184.35-2.137.672L31.4 22.07c-.855.288-1.442.486-1.89.676-.436.186-.667.334-.828.488-.358.34-.609.777-.722 1.258-.051.217-.063.491-.003.961.062.482.187 1.09.37 1.973l3.91 18.865 24.702-8.314z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "M61.475 34.736c-.374-1.11-.635-1.885-.888-2.473-.248-.576-.454-.89-.676-1.107a3.12 3.12 0 0 0-1.73-.858c-.306-.046-.68-.02-1.29.13-.62.155-1.396.415-2.506.788L39.83 36.115c-.797.268-1.338.451-1.745.626-.395.17-.581.3-.7.42-.287.294-.474.67-.534 1.077-.025.167-.015.394.088.812.107.429.288.97.556 1.767l3.556 10.565c.268.797.451 1.338.626 1.744.17.396.3.582.42.7.294.288.67.475 1.077.535.167.024.394.015.812-.089.43-.106.97-.287 1.768-.556l14.555-4.898c1.11-.374 1.885-.636 2.472-.888.577-.248.89-.455 1.108-.676a3.12 3.12 0 0 0 .858-1.73c.045-.306.02-.68-.131-1.29-.154-.62-.415-1.397-.788-2.507zM24.967 45.69c-.272-.808-.46-1.366-.637-1.79-.173-.417-.308-.636-.441-.787a2.54 2.54 0 0 0-1.708-.847c-.2-.016-.457.01-.893.123-.445.117-1.003.304-1.81.576-.809.271-1.366.46-1.79.636-.417.173-.636.308-.787.441a2.53 2.53 0 0 0-.848 1.708c-.015.2.01.457.124.893.117.445.304 1.003.576 1.81l3.056 9.083c.321.954.544 1.612.757 2.11.21.485.377.735.549.903.382.374.873.618 1.402.696.238.035.538.018 1.052-.11.525-.13 1.183-.35 2.137-.672l1.177-.396c.64-.215 1.064-.359 1.38-.495.305-.13.427-.222.496-.292.2-.205.331-.468.373-.75.014-.098.013-.25-.067-.573-.083-.334-.225-.758-.44-1.398z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m63.17 53.359-2.18-4.09-2.166.73zM49.32 57.59l-2.18-4.09-2.166.73zM27.787 65.267l-.736-4.575 2.167-.73z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    d: "M50.057 17.746a1.767 1.767 0 0 0-2.075-1.082l-4.8 1.19 3.298 15.771 8.565-2.882z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BFD4D9",
    strokeWidth: 2,
    d: "M43.741 39.37c-.272-.807-.46-1.364-.636-1.79-.173-.416-.308-.635-.442-.786a2.53 2.53 0 0 0-1.707-.847c-.201-.015-.457.01-.893.124-.446.116-1.003.303-1.811.575s-1.365.46-1.79.636c-.416.174-.635.308-.786.442a2.53 2.53 0 0 0-.848 1.707c-.015.201.01.457.124.893.116.446.303 1.003.575 1.811l3.658 10.87c.216.64.36 1.064.495 1.38.132.305.223.427.293.495.204.2.467.331.75.373.098.014.25.013.572-.067.334-.083.758-.224 1.399-.44l1.177-.396c.954-.321 1.612-.543 2.109-.757.486-.21.736-.377.903-.548.375-.383.618-.874.697-1.403.035-.237.017-.538-.11-1.052-.13-.525-.351-1.183-.672-2.137z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33.25 121.745 34 115l.75 6.745a3 3 0 0 0 2.488 2.628L41 125l-3.762.627a3 3 0 0 0-2.489 2.628L34 135l-.75-6.745a3 3 0 0 0-2.488-2.628L27 125l3.762-.627a3 3 0 0 0 2.489-2.628"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 102.5,
    r: 2.5,
    fill: "#BFBAFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4D9",
    stroke: "#BFD4D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M135.474 30.577 136 29l.526 1.577a3 3 0 0 0 1.897 1.897L140 33l-1.577.526a3 3 0 0 0-1.897 1.897L136 37l-.526-1.577a3 3 0 0 0-1.897-1.897L132 33l1.577-.526a3 3 0 0 0 1.897-1.897"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 92,
    r: 32,
    fill: "#BFD4D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M86.479 78.072h9.043c.62 0 1.434.426 1.816.951l2.485 3.868c.243.377.646.605 1.077.605h5.345c1.247 0 2.255 1.074 2.255 2.406v17.476c0 1.329-1.008 2.407-2.255 2.407H75.756c-1.246 0-2.256-1.075-2.256-2.407V85.902c0-1.33 1.01-2.406 2.257-2.406h5.366c.416 0 .807-.219 1.043-.584l2.496-3.889c.383-.524 1.2-.951 1.817-.951m13.047 8.776c0 .765.602 1.385 1.346 1.385s1.346-.62 1.346-1.385-.601-1.386-1.346-1.386c-.744 0-1.346.621-1.346 1.386m-16.154 6.928c0 4.591 3.616 8.313 8.077 8.313s8.077-3.722 8.077-8.313c0-4.593-3.615-8.314-8.077-8.314s-8.077 3.72-8.077 8.314m-6.058-14.78h2.245c.62 0 1.12.616 1.12 1.386v1.385h-4.487v-1.385c0-.766.5-1.386 1.122-1.386m7.853 14.78c0-3.573 2.811-6.467 6.282-6.467s6.282 2.894 6.282 6.467c0 3.571-2.812 6.466-6.282 6.466s-6.282-2.895-6.282-6.466",
    clipRule: "evenodd"
  })));
};
export default SvgEmptyImageGreen;